import { render } from "./Yilou.vue?vue&type=template&id=ca1e1f80&scoped=true"
import script from "./Yilou.vue?vue&type=script&lang=js"
export * from "./Yilou.vue?vue&type=script&lang=js"

import "./Yilou.vue?vue&type=style&index=0&id=ca1e1f80&scoped=true&lang=css"

import exportComponent from "/Users/windy/work/vue/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1e1f80"]])

export default __exports__